const CheckInCircleActive = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 1C9.82441 1 7.69767 1.64514 5.88873 2.85383C4.07979 4.06253 2.66989 5.78049 1.83733 7.79048C1.00477 9.80047 0.78693 12.0122 1.21137 14.146C1.6358 16.2798 2.68345 18.2398 4.22183 19.7782C5.76021 21.3165 7.72022 22.3642 9.85401 22.7886C11.9878 23.2131 14.1995 22.9952 16.2095 22.1627C18.2195 21.3301 19.9375 19.9202 21.1462 18.1113C22.3549 16.3023 23 14.1756 23 12C23 10.5555 22.7155 9.12506 22.1627 7.79048C21.6099 6.4559 20.7996 5.24327 19.7782 4.22182C18.7567 3.20038 17.5441 2.39013 16.2095 1.83732C14.8749 1.28452 13.4445 1 12 1ZM16.752 10.9L11.626 16.037C11.5063 16.1568 11.3639 16.2516 11.2071 16.3158C11.0504 16.38 10.8824 16.4124 10.713 16.411C10.5453 16.4121 10.379 16.3796 10.2241 16.3154C10.0692 16.2512 9.9287 16.1565 9.811 16.037L7.248 13.452C7.01833 13.2108 6.89204 12.8894 6.8961 12.5564C6.90016 12.2234 7.03425 11.9052 7.26973 11.6697C7.50522 11.4342 7.82344 11.3002 8.15644 11.2961C8.48945 11.292 8.81084 11.4183 9.052 11.648L10.713 13.298L14.948 9.074C15.0679 8.95555 15.21 8.86187 15.366 8.79832C15.5222 8.73476 15.6892 8.70258 15.8578 8.7036C16.0263 8.70462 16.193 8.73883 16.3483 8.80427C16.5036 8.86971 16.6445 8.9651 16.763 9.085C16.8815 9.2049 16.9751 9.34695 17.0387 9.50305C17.1022 9.65915 17.1344 9.82624 17.1334 9.99477C17.1324 10.1633 17.0982 10.33 17.0327 10.4853C16.9673 10.6406 16.8719 10.7815 16.752 10.9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CheckInCircleActive;
